import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { LanguageProvider, useLanguage } from './Context/LanguageContext';
import Navbar from './Components/Navbar';
import Home from './Components/Home';
import MembersMap from './Components/MembersMap';
import Duyurular from './Components/Duyurular';
import IsIlanlari from './Components/IsIlanlari';
import Raporlar from './Components/Raporlar';
import Gizlilik from './Components/Gizlilik';
import NotFound from './Components/NotFound';
import Footer from './Components/Footer';
import ScrollToTop from './Components/ScrollToTop';
import SEOManager from './Components/SEOManager';

const AnimatedRoutes = ({ data }) => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home data={data} />} />
        <Route path="/members" element={<MembersMap />} />
        <Route path="/announcements" element={<Duyurular />} />
        <Route path="/jobs" element={<IsIlanlari />} />
        <Route path="/reports" element={<Raporlar />} />
        <Route path="/privacy" element={<Gizlilik />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
};

const AppContent = () => {
  const { data } = useLanguage();

  if (!data) return (
    <div className="app-loading">
      <img src="/images/logo.png" alt="KTGPB" className="app-loading-logo" />
      <div className="app-loading-spinner"></div>
    </div>
  );

  return (
    <Router>
      <ScrollToTop />
      <SEOManager />
      <div className="App">
        <Navbar />
        <AnimatedRoutes data={data} />
        <Footer data={data} />
      </div>
    </Router>
  );
};

const App = () => {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
};

export default App;
